import React from 'react';

export function formatLastActive(lastActiveAt) {
  if (!lastActiveAt) return '';
  const diff = Date.now() - new Date(lastActiveAt).getTime();
  const m = Math.floor(diff / 60000);
  if (m < 1) return 'Active now';
  if (m < 60) return `Active ${m}m ago`;
  const h = Math.floor(m / 60);
  if (h < 24) return `Active ${h}h ago`;
  const d = Math.floor(h / 24);
  if (d < 30) return `Active ${d}d ago`;
  return 'Active a while ago';
}

// Small colored dot — green while online, gray otherwise. `size` in px.
export function PresenceDot({ online, size = 10, style = {} }) {
  return (
    <span
      title={online ? 'Online' : 'Offline'}
      style={{
        display: 'inline-block',
        width: size, height: size, borderRadius: '50%',
        background: online ? '#22c55e' : '#c7c7c7',
        border: '1.5px solid #fff',
        boxShadow: '0 0 0 1px rgba(0,0,0,0.06)',
        flexShrink: 0,
        ...style,
      }}
    />
  );
}

// Dot + "Active Xh ago" text, for card grids.
export function PresenceLabel({ online, lastActiveAt, style = {} }) {
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: '5px', fontSize: '12px', color: '#8a8a8a', fontFamily: '"Instrument Sans", "Segoe UI", system-ui, sans-serif', ...style }}>
      <PresenceDot online={online} size={7} style={{ border: 'none' }} />
      {online ? 'Online now' : formatLastActive(lastActiveAt)}
    </span>
  );
}
